var _defs, _circle, _g, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "avatarGreenBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#22c55e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#16a34a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#14532d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "userShadow",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000",
    stopOpacity: 0.18
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "url(#avatarGreenBg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,108 C24,92.5 40,80 64,80 C88,80 104,92.5 104,108 C104,112 101,124 101,124 L27,124 C27,124 24,112 24,108 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,68 L74,68 L74,82 L54,82 Z",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 50,
    r: 22,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,108 C24,92.5 40,80 64,80 C88,80 104,92.5 104,108 C104,112 101,124 101,124 L27,124 C27,124 24,112 24,108 Z",
    fill: "url(#userShadow)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 36,
    r: 2.5,
    fill: "#ffffff",
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 44,
    r: 1.2,
    fill: "#ffffff",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvat);
export default __webpack_public_path__ + "static/media/avat.c3c7afa654617269224a09715f1c522c.svg";
export { ForwardRef as ReactComponent };